import { useEffect } from "react";
import { api } from "@/lib/api";

// FaviconSetter — reads `site_favicon` from Site Settings and swaps the
// document's <link rel="icon"> at runtime. When the admin uploads a new
// favicon, saving Site Settings updates the tab icon site-wide on the
// next page load. Empty setting = keep the built-in mark declared in
// public/index.html.
export const FaviconSetter = () => {
  useEffect(() => {
    let cancelled = false;
    api.get("/settings")
      .then((r) => {
        if (cancelled) return;
        const url = (r.data && r.data.site_favicon) || "";
        if (!url) return;
        let link = document.querySelector('link[rel="icon"]');
        if (!link) {
          link = document.createElement("link");
          link.rel = "icon";
          document.head.appendChild(link);
        }
        link.setAttribute("data-testid", "site-favicon");
        link.href = url;
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return null;
};
